/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-restricted-syntax */
/* eslint-disable array-callback-return */
/* eslint-disable react/no-did-update-set-state */
/* eslint-disable indent */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import Slider from 'rc-slider';
import Commons from '../../../commons/commons';
import { SetOfertaFiltrados } from '../../../redux/actions/ofertas-actions';
import '../../filtros/filtros.css';

const { Range } = Slider;

class FiltrosOfertas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cantNoches: [],
      paquetes: [],
      hoteles: [],
      categoriaHotel: [],
      proveedores: [],
      precioMinimo: 0,
      precioMaximo: null,
      precio: [0, 1],
      DepartureDate: [],
      invertirPrecio: false,
      disponible: true,
      filtroCupos: false,
      aplicando: false,
      origen: [],
      destino: [],
      servicios: [],
      regimen: [],
      label: [],
    };
    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.handleCheckboxHoteles = this.handleCheckboxHoteles.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.original !== prevProps.original) {
      this.prepararFiltros(this.props.original);
      this.setState({ paquetes: this.props.original }, () => this.aplicarFiltros());
    }
  }

  getFinalPriceOffer = (oferta) => {
    const { currency } = this.props;
    const { host } = Commons.getLocationInformation();

    let cantPax = 0;
    const urlPasajerosOriginal = new URL(`https://${host}/buscarxpaquetes${oferta.url}`);
    const distribucionCodigo = urlPasajerosOriginal.searchParams.get('h');
    const distribucion = Commons.obtenerDistribucion(distribucionCodigo);

    distribucion.map((habitacion) => {
      cantPax = cantPax + (
        parseInt(habitacion.adultos) + habitacion.menores.length
      );
    });

    const price = (currency && oferta.prices.find((price) => price.currency === currency.code)) || oferta.prices[0];

    let priceWithTaxes = Math.ceil(price.netPrice + price.taxes + price.iva);

    if (price.currency === 'ARS') {
      priceWithTaxes = priceWithTaxes + price.countryTaxes;
    }

    return priceWithTaxes / cantPax;
  }

    prepararFiltros = (ofertas) => {
    const cantNoches = [];
    const origen = [];
    const destino = [];
    const servicios = [];
    const label = [];
    const DepartureDate = [];
    const regimen = [];
    const categoriaHotel = [];
    const contadores = {
      categoriaHotel: null,
      hoteles: null,
      proveedores: null,
      cantNoches: null,
      origen: null,
      destino: null,
      servicios: null,
      DepartureDate: null,
      label: null,
      regimen: null,
    };
    let max = 1,
min = 0;
    let cont = 0;

    //categoriaHotel
    for (let i = 1; i <= 5; i++) {
      if (i === 1) {
        categoriaHotel.push({ nombre: '1 Estrella', visible: false });
      } else {
        const nombre = `${i} Estrellas`;
        categoriaHotel.push({ nombre, visible: false });
      }
    }
    contadores.categoriaHotel = 5;
    //this.setState({categoriaHotel});

    //cantidad de noches
    cont = 0;
    ofertas.map((p) => {
      let encontrado = false;
      const noches = p.nights;
      cantNoches.map((n) => {
        if (n.nombre === noches) {
          encontrado = true;
        }
      });
      if (!encontrado) {
        cont++;
        cantNoches.push({ nombre: noches, visible: false });
        encontrado = false;
      }
    });
    contadores.cantNoches = cont;
    //this.setState({cantNoches});

    //Origen
    cont = 0;
    ofertas.map((p) => {
      let encontrado = false;
      const { origin } = p;
      origen.map((o) => {
        if (o.nombre === origin) {
          encontrado = true;
        }
      });
      if (!encontrado) {
        cont++;
        origen.push({ nombre: origin, visible: false });
        encontrado = false;
      }
    });
    contadores.origen = cont;
    //this.setState({origen});
    //destino
    cont = 0;
    ofertas.map((p) => {
      let encontrado = false;
      const { destination } = p;
      destino.map((d) => {
        if (d.nombre === destination) {
          encontrado = true;
        }
      });
      if (!encontrado) {
        cont++;
        destino.push({ nombre: destination, visible: false });
        encontrado = false;
      }
    });
    contadores.destino = cont;
    //this.setState({destino});
    //servicios
    cont = 0;
    ofertas.map((p) => {
      let encontrado = false;
      p.services.map((s) => {
        servicios.map((sr) => {
          if (sr.nombre === s) {
            encontrado = true;
          }
        });
        if (!encontrado) {
          cont++;
          servicios.push({ nombre: s, visible: false });
          encontrado = false;
        }
      });
    });
    contadores.servicios = cont;
    //this.setState({servicios});
    //regimen
    cont = 0;
    ofertas.map((p) => {
      let encontrado = false;
      p.hotels.map((r) => {
        regimen.map((rg) => {
          if (rg.nombre === r.regime) {
            encontrado = true;
          }
        });
        if (!encontrado) {
          cont++;
          regimen.push({ nombre: r.regime, visible: false });
          encontrado = false;
        }
      });
    });
    contadores.regimen = cont;
    //this.setState({regimen});
    //DepartureDate
    cont = 0;
    ofertas.map((p) => {
      let encontrado = false;
      const { departureDate } = p;
      DepartureDate.map((dp) => {
        if (dp.nombre === departureDate) {
          encontrado = true;
        }
      });
      if (!encontrado) {
        cont++;
        DepartureDate.push({ nombre: departureDate, visible: false });
        encontrado = false;
      }
    });
    contadores.DepartureDate = cont;
    //this.setState({DepartureDate});
    //label
    cont = 0;
    ofertas.map((p) => {
      let encontrado = false;
      const labels = p.offerLabel;
      label.map((l) => {
        if (l.nombre === labels) {
          encontrado = true;
        }
      });
      if (!encontrado) {
        cont++;
        label.push({ nombre: labels, visible: false });
        encontrado = false;
      }
    });
    contadores.label = cont;
    //this.setState({label});

    //precios
        ofertas.map((oferta) => {
      const finalPriceByPax = this.getFinalPriceOffer(oferta);

      max = max < finalPriceByPax || max === 0 ? finalPriceByPax : max;
      min = min > finalPriceByPax || min === 0 ? finalPriceByPax : min;
    });

        this.setState({
      categoriaHotel,
      cantNoches,
      origen,
      destino,
      servicios,
      regimen,
      DepartureDate,
      label,
      precioMaximo: Math.ceil(max / 100) * 100,
      precioMinimo: Math.floor(min / 100) * 100,
      precio: [Math.floor(min / 100) * 100, Math.ceil(max / 100) * 100],
    });
    };

    aplicarFiltros = () => {
    let paquetes = { ...this.props.original };

    if (this.contadorChecks(this.state.cantNoches)) {
      paquetes = this.aplicarFiltroCantNoches(paquetes);
    }
    if (this.contadorChecks(this.state.origen)) {
      paquetes = this.aplicarFiltroOrigen(paquetes);
    }
    if (this.contadorChecks(this.state.destino)) {
      paquetes = this.aplicarFiltroDestino(paquetes);
    }
    if (this.contadorChecks(this.state.servicios)) {
      paquetes = this.aplicarFiltroServicios(paquetes);
    }
    if (this.contadorChecks(this.state.DepartureDate)) {
      paquetes = this.aplicarFiltroFechas(paquetes);
    }
    if (this.contadorChecks(this.state.label)) {
      paquetes = this.aplicarFiltroLabel(paquetes);
    }
    if (this.contadorChecks(this.state.regimen)) {
      paquetes = this.aplicarFiltroRegimen(paquetes);
    }
    paquetes = this.aplicarFiltroPrecios(paquetes);

    if (paquetes !== this.props.original && paquetes !== this.state.paquetes) {
      this.setState({ paquetes }, () => this.props.SetOfertaFiltrados(paquetes));
    }
    }

    contadorChecks = (lista) => {
    let cont = 0;
    for (const index in lista) {
      const item = lista[index];
      if (item.visible) {
        cont++;
      }
    }
    return (cont > 0 && cont < Commons.length(lista));
    }

    aplicarFiltroCantNoches = (paquetes) => {
    const { cantNoches } = this.state;
    const paqueteNuevo = [];
    for (const paqueteKey in paquetes) {
      const paquete = paquetes[paqueteKey];
      for (const cantNochesKey in cantNoches) {
        if (cantNoches[cantNochesKey].visible && cantNoches[cantNochesKey].nombre === paquete.nights) {
          paqueteNuevo.push(paquete);
        }
      }
    }
    return paqueteNuevo;
    };

    aplicarFiltroOrigen = (paquetes) => {
    const { origen } = this.state;
    const paqueteNuevo = [];
    for (const paqueteKey in paquetes) {
      const paquete = paquetes[paqueteKey];
      for (const origenkey in origen) {
        if (origen[origenkey].visible && origen[origenkey].nombre === paquete.origin) {
          paqueteNuevo.push(paquete);
        }
      }
    }

    return paqueteNuevo;
    };

    aplicarFiltroDestino = (paquetes) => {
    const { destino } = this.state;
    const paqueteNuevo = [];
    for (const paqueteKey in paquetes) {
      const paquete = paquetes[paqueteKey];
      for (const destinoKey in destino) {
        if (destino[destinoKey].visible && destino[destinoKey].nombre === paquete.destination) {
          paqueteNuevo.push(paquete);
        }
      }
    }
    return paqueteNuevo;
    };

    aplicarFiltroServicios = (paquetes) => {
    const { servicios } = this.state;
    const paqueteNuevo = [];
    for (const paquetekey in paquetes) {
      const paquete = paquetes[paquetekey];
      for (let i = 0; i < Commons.length(paquete.services); i++) {
        const servicioLista = paquete.services[i];
        for (const serviciosKey in servicios) {
          if (servicios[serviciosKey].visible && servicios[serviciosKey].nombre === servicioLista) {
            paqueteNuevo.push(paquete);
          }
        }
      }
    }
    //   for(let paquete in paquetes) {
    //       paquete = paquetes[paquete];
    //       for (let servicio in servicios) {
    //           servicio = servicios[servicio];
    //           paqueteNuevo.push(servicio);
    //       }
    //   }

    return paqueteNuevo;
    };

    aplicarFiltroRegimen = (paquetes) => {
    const { regimen } = this.state;
    const paqueteNuevo = [];
    for (const paqueteKey in paquetes) {
      const paquete = paquetes[paqueteKey];
      for (const regimenKey in regimen) {
        for (const hotel in paquete.hotels) {
          if (regimen[regimenKey].visible && regimen[regimenKey].nombre === paquete.hotels[hotel].regime) {
            paqueteNuevo.push(paquete);
          }
        }
      }
    }
    return paqueteNuevo;
    };

    aplicarFiltroFechas = (paquetes) => {
    const { DepartureDate } = this.state;
    const paqueteNuevo = [];
    for (const paqueteKey in paquetes) {
      const paquete = paquetes[paqueteKey];
      for (const fechaKey in DepartureDate) {
        if (DepartureDate[fechaKey].visible && DepartureDate[fechaKey].nombre === paquete.departureDate) {
          paqueteNuevo.push(paquete);
        }
      }
    }
    return paqueteNuevo;
    };

    aplicarFiltroLabel = (paquetes) => {
    const { label } = this.state;
    const paqueteNuevo = [];
    for (const paqueteKey in paquetes) {
      const paquete = paquetes[paqueteKey];
      for (const labelkey in label) {
        if (label[labelkey].visible && label[labelkey].nombre === paquete.offerLabel) {
          paqueteNuevo.push(paquete);
        }
      }
    }
    return paqueteNuevo;
    };

    aplicarFiltroPrecios = (ofertas) => {
    const filtrados = [];
        const min = this.state.precio[0];
        const max = this.state.precio[1];

    Object.keys(ofertas).map((key) => {
      const oferta = ofertas[key];
      const finalPriceByPax = this.getFinalPriceOffer(oferta);
      if (finalPriceByPax >= min && finalPriceByPax <= max) {
        filtrados.push(oferta);
      }
    });

    return filtrados;
    };

    aplicarFiltroCategoriaHotel = (paquetes) => {
    const { categoriaHotel } = this.state;
    const paqueteNuevo = [];
    for (let p in paquetes) {
      p = paquetes[p];
      let estado = false;
      p.salidas.map((s) => {
        s.hoteles.map((h) => {
          for (let item in categoriaHotel) {
            item = categoriaHotel[item];
            const clase = item.nombre.split(' ')[0];
            if (item.visible && h.clase === clase) {
              estado = true;
            }
          }
        });
      });
      if (estado) {
        paqueteNuevo.push(p);
      }
    }
    return paqueteNuevo;
    }

    armarCantNoches = (cantNoches) => {
    const lista = [];
    for (let item in cantNoches) {
      item = cantNoches[item];
      const clase = item.visible === true ? 'itemSeleccionado' : 'item';
      lista.push(
        <div key={item.nombre} id='cantNoches1' className={clase} onClick={this.handleCheckbox}>
          <input
            id='cantNoches'
            className='checkbox-margin'
            name={item.nombre}
            type='checkbox'
            checked={item.visible}
            onChange={this.handleCheckbox}
          />
          {item.nombre}
          {' '}
          Noches
          <br />
        </div>,
);
    }
    return lista.map((c) => c);
    }

    armarOrigen = (origen) => {
    const lista = [];
    for (let item in origen) {
      item = origen[item];
      const clase = item.visible === true ? 'itemSeleccionado' : 'item';
      lista.push(
        <div key={item.nombre} id='origen1' className={clase} onClick={this.handleCheckbox}>
          <input id='origen' checked={item.visible} className='checkbox-margin' name={item.nombre} type='checkbox' />
          {item.nombre}
        </div>,
      );
    }
    return lista.map((c) => c);
    };

    armarDestino = (destino) => {
    const lista = [];
    for (let item in destino) {
      item = destino[item];
      const clase = item.visible === true ? 'itemSeleccionado' : 'item';
      lista.push(
        <div key={item.nombre} id='destino1' className={clase} onClick={this.handleCheckbox}>
          <input id='destino' checked={item.visible} className='checkbox-margin' name={item.nombre} type='checkbox' />
          {item.nombre}
        </div>,
      );
    }
    return lista.map((c) => c);
    };

    armarServicio = (servicios) => {
    const lista = [];
    for (let item in servicios) {
      item = servicios[item];
      const clase = item.visible === true ? 'itemSeleccionado' : 'item';
      lista.push(
        <div key={item.nombre} id='servicios1' className={clase} onClick={this.handleCheckbox}>
          <input id='servicios' checked={item.visible} className='checkbox-margin' name={item.nombre} type='checkbox' />
          {item.nombre}
        </div>,
      );
    }
    return lista.map((c) => c);
    };

    armarRegimen = (regimen) => {
    const lista = [];
    for (let item in regimen) {
      item = regimen[item];
      const clase = item.visible === true ? 'itemSeleccionado' : 'item';
      lista.push(
        <div key={item.nombre} id='regimen1' className={clase} onClick={this.handleCheckbox}>
          <input id='regimen' checked={item.visible} className='checkbox-margin' name={item.nombre} type='checkbox' />
          {item.nombre}
        </div>,
      );
    }
    return lista.map((c) => c);
    };

    armarFecha = (departureDate) => {
    const lista = [];
    for (let item in departureDate) {
      item = departureDate[item];
      const monthDate = moment(item.nombre).format('MM YYYY');
      const DayDate = moment(item.nombre).format('DD YYYY');
      const YearDate = moment(item.nombre).format('YYYY');
      const clase = item.visible === true ? 'itemSeleccionado' : 'item';
      lista.push(
        <>
          <div key={item.nombre} id='DepartureDate1' className={clase} onClick={this.handleCheckbox}>
            <input id='DepartureDate' checked={item.visible} className='checkbox-margin' name={item.nombre} type='checkbox' />
            {`${moment(DayDate, 'D').format('DD')
                            } de ${
                            moment(monthDate, 'M').format('MMMM')
                            } de ${
                            moment(YearDate, 'Y').format('YYYY')}`}
          </div>
        </>,
      );
    }
    return lista.map((c) => c);
    };

    armarLabel = (label) => {
    const lista = [];
    for (let item in label) {
      item = label[item];
      const clase = item.visible === true ? 'itemSeleccionado' : 'item';
      lista.push(
        <div key={item.nombre} id='label1' className={clase} onClick={this.handleCheckbox}>
          <input id='label' checked={item.visible} className='checkbox-margin' name={item.nombre} type='checkbox' />
          {item.nombre}
        </div>,
      );
    }
    return lista.map((c) => c);
    };

    handleCheckboxHoteles = (event) => {
    event.preventDefault();
    const target = event.target.querySelector('input');
    const { name } = target;
    const state = { ...this.state[target.id] };

    for (let item in state) {
      item = state[item];
      if (item.nombre === name) {
        item.visible = !item.visible;
      }
    }

    this.setState({ [target.id]: state }, () => this.aplicarFiltros());
    }

    handleInvertir = () => {
    const invertirPrecio = !this.state.invertirPrecio;
    this.setState({ invertirPrecio }, () => this.aplicarFiltros());
    }

    handleCheckbox(event) {
    event.preventDefault();
    let target = event.target.querySelector('input');
    if (target == null) {
      target = event.target;
    }
    const state = { ...this.state[target.id] };
    let { name } = target;
    if (name == null) {
      name = target.title;
    }

    for (let item in state) {
      item = state[item];
      if (item.nombre === name) {
        item.visible ? item.visible = false : item.visible = true;
      }
    }
    this.setState({ [target.id]: state }, () => this.aplicarFiltros());
    }

    handleDesmarcarTodo = (e) => {
    e.preventDefault();
    const state = { ...this.state[e.target.id] };
    for (let item in state) {
      item = state[item];
      item.visible = false;
    }
    this.setState({ [e.target.id]: state }, () => this.aplicarFiltros());
    };

    onSliderChangePrecio = (precio) => {
    this.setState({ precio });
    };

    onSliderChangeFecha = (fechas) => {
    this.setState({ fechas });
    };

    disableCheck = () => {
      const sinCupo = document.getElementById('sinCupo');
      const conCupo = document.getElementById('tieneCupo');

      conCupo.checked ? (sinCupo.setAttribute('disabled', 'disabled'), sinCupo.setAttribute('value', 'false')) : (sinCupo.removeAttribute('disabled'), sinCupo.setAttribute('value', 'true'));
      sinCupo.checked ? (conCupo.setAttribute('disabled', 'disabled'), conCupo.setAttribute('value', 'false')) : (conCupo.removeAttribute('disabled'), conCupo.setAttribute('value', 'true'));
    }

    handleFiltroCupos = () => {
      const { filtroCupos } = this.state;
      this.setState({ filtroCupos: !filtroCupos }, () => this.aplicarFiltros());
    }

    aplicarFiltroCupos = (paquetes) => {
    this.setState({
      cargando: true,
    });

    const filtrados = [];

    for (let i = 0; i < Commons.length(paquetes); i++) {
      const paquete = paquetes[i];
      const p = { ...paquete };
      p.salidas = [];
      for (let j = 0; j < Commons.length(paquete.salidas); j++) {
        const salida = paquete.salidas[j];

        if (salida.cupos > 0) {
          p.salidas.push({ ...salida });
        }

      }
      if (Commons.length(p.salidas) !== 0) {
        filtrados.push(p);
      }
    }

    this.setState({
      cargando: false,
    });
    return filtrados;
    }

    render() {
    const { precio, precioMinimo, precioMaximo, DepartureDate, servicios, origen, destino, cantNoches, label,
      regimen } = this.state;

    if (this.props.original !== [] && this.props.original) {
      return (
        <div>
          <div className='panel panel-default custom'>
            <div className='panel-body' style={{ background: '#eee' }}>
              <label>Precio</label>
              <div style={{ marginTop: '20px', marginBottom: '10px' }}>
                <Range
                  allowCross={false}
                  value={precio}
                  min={precioMinimo}
                  max={precioMaximo}
                  onChange={this.onSliderChangePrecio}
                  onAfterChange={this.aplicarFiltros}
                  trackStyle={[{ backgroundColor: '#000000' }, { backgroundColor: '#000000' }]}
                  handleStyle={[{ backgroundColor: '#000000' }, { backgroundColor: '#000000' }]}
                />
                <br />
              </div>
              <input
                style={{
                width: '31%',
                margin: '0px',
                padding: '6px',
                float: 'left',
                display: 'inline-block',
                background: '#ffffff',
              }}
                className='form-control'
                value={`$${precio[0]}`}
                readOnly
              />
              <input
                style={{
                width: '31%',
                margin: '0px',
                padding: '6px',
                float: 'right',
                display: 'inline-block',
                background: '#ffffff',
              }}
                className='form-control'
                value={`$${precio[1]}`}
                readOnly
              />
            </div>
          </div>

          <div className='panel panel-default custom'>
            <div className='panel-body' style={{ background: '#eee' }}>
              <label>Cantidad de Noches</label>
              <div style={{ float: 'right', margin: '0px', padding: '0px' }} className=''>
                <label id='cantNoches' className='desmarcarTodo' onClick={this.handleDesmarcarTodo}>
                  Desmarcar
                  Todo
                </label>
                <br />
              </div>
              <br />
              {
                Commons.length(cantNoches) !== 0
                  ? this.armarCantNoches(cantNoches)
                  : <span>N/A</span>
              }
            </div>
          </div>
          <div className='panel panel-default custom'>
            <div className='panel-body' style={{ background: '#eee' }}>
              <label>Origen</label>
              <div style={{ float: 'right', margin: '0px', padding: '0px' }} className=''>
                <label id='origen' className='desmarcarTodo' onClick={this.handleDesmarcarTodo}>
                  Desmarcar
                  Todo
                </label>
              </div>
              {
                Commons.length(origen) !== 0
                  ? this.armarOrigen(origen)
                  : <span>N/A</span>
              }
            </div>
          </div>
          <div className='panel panel-default custom'>
            <div className='panel-body' style={{ background: '#eee' }}>
              <label>Destino</label>
              <div style={{ float: 'right', margin: '0px', padding: '0px' }} className=''>
                <label id='destino' className='desmarcarTodo' onClick={this.handleDesmarcarTodo}>
                  Desmarcar
                  Todo
                </label>
              </div>
              {
                Commons.length(destino) !== 0
                  ? this.armarDestino(destino)
                  : <span>N/A</span>
              }
            </div>
          </div>
          <div className='panel panel-default custom'>
            <div className='panel-body' style={{ background: '#eee' }}>
              <label>Servicios</label>
              <div style={{ float: 'right', margin: '0px', padding: '0px' }} className=''>
                <label id='servicios' className='desmarcarTodo' onClick={this.handleDesmarcarTodo}>
                  Desmarcar
                  Todo
                </label>
              </div>
              {
                Commons.length(servicios) !== 0
                  ? this.armarServicio(servicios)
                  : <span>N/A</span>
              }
            </div>
          </div>
          <div className='panel panel-default custom'>
            <div className='panel-body' style={{ background: '#eee' }}>
              <label>Regimen</label>
              <div style={{ float: 'right', margin: '0px', padding: '0px' }} className=''>
                <label id='regimen' className='desmarcarTodo' onClick={this.handleDesmarcarTodo}>
                  Desmarcar
                  Todo
                </label>
              </div>
              {
                Commons.length(regimen) !== 0
                  ? this.armarRegimen(regimen)
                  : <span>N/A</span>
              }
            </div>
          </div>
          {
            Commons.length(label) !== 1 && Commons.length(label) !== undefined ? (
              <div className='panel panel-default custom'>
                <div className='panel-body' style={{ background: '#eee' }}>
                  <label>Tipo de oferta</label>
                  <div style={{ float: 'right', margin: '0px', padding: '0px' }} className=''>
                    <label id='label' className='desmarcarTodo' onClick={this.handleDesmarcarTodo}>
                      Desmarcar
                      Todo
                    </label>
                  </div>
                  {
                    this.armarLabel(label)
                  }
                </div>
              </div>
     )
              : null
          }
          <div className='panel panel-default custom'>
            <div className='panel-body' style={{ background: '#eee' }}>
              <label>Fechas</label>
              <div style={{ float: 'right', margin: '0px', padding: '0px' }} className=''>
                <label id='fechas' className='desmarcarTodo' onClick={this.handleDesmarcarTodo}>
                  Desmarcar
                  Todo
                </label>
              </div>
              {

                Commons.length(DepartureDate) !== 0
                  ? this.armarFecha(DepartureDate)
                  : <span>N/A</span>
              }
            </div>
          </div>
        </div>

      );
    }

      return null;

    }
}

const mapStatetoProps = (state) => ({
  offers: state.offers,
  currency: state.applicationState.currency,
});

const mapDispatchtoProps = (dispatch) => bindActionCreators({ SetOfertaFiltrados }, dispatch);

export default connect(mapStatetoProps, mapDispatchtoProps)(FiltrosOfertas);
